import { render, staticRenderFns } from "./PolicySchedtag.vue?vue&type=template&id=5bb82502&"
import script from "./PolicySchedtag.vue?vue&type=script&lang=js&"
export * from "./PolicySchedtag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports